/**
 * Visit reward teaser for the order confirmation.
 *
 * Asks gottea-api whether the just-placed order is the customer's 1st-4th
 * visit. The response only carries reward copy and the unlock time. The coupon
 * itself is created the next morning, so there is nothing to reveal here.
 */

import { API_BASE_URL } from "../config/payments";

/**
 * @returns {Promise<null | {
 *   milestone: number,
 *   reward: { title: string, description: string, label: string, validityDays: number },
 *   unlockAt: string,
 *   serverNow: string,
 * }>} the projection when eligible, otherwise null. Never throws.
 */
export async function fetchVisitRewardStatus(orderId, phone, { signal } = {}) {
  if (!orderId || !phone) return null;
  try {
    const url =
      `${API_BASE_URL}/payments/order/${encodeURIComponent(orderId)}/visit-reward` +
      `?phone=${encodeURIComponent(phone)}`;
    const response = await fetch(url, { signal });
    if (!response.ok) return null;
    const body = await response.json().catch(() => null);
    const data = body?.success ? body.data : null;
    if (!data?.eligible || !data.reward?.title || !data.unlockAt) return null;
    return data;
  } catch (error) {
    return null;
  }
}
